
import { sendAPIRequest } from "shared/utils/requests";


export default class CallsWebsocket {
  constructor(url, auth, onCallRemoved) {
    this.url = url;
    this.auth = auth;
    this.onCallRemoved = onCallRemoved;
    this.closed = false;
    this.connected = false;
  }

  connect() {
    return new Promise((resolve, reject) => {
      if (this.closed) {
        reject();
        return;
      }
      try {
        this.socket = new WebSocket(this.url);
        this.socket.onmessage = this.receiveMessage;
        this.socket.onopen = () => {
          this.connected = true;
          this.socket.send(`auth$${this.auth}`);
          resolve();
        };
        this.socket.onerror = console.error;
        this.socket.onclose = this.onClose;
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  }

  close() {
    this.closed = true;
    this.socket.close();
  }

  onClose = () => {
    this.connected = false;
    if (!this.closed) {
      setTimeout(() => this.connect(), 1000);
    }
  }

  receiveMessage = (message) => {
    if (message.type == 'error') {
      console.error(message);
      return;
    }
    const packet = JSON.parse(message.data);
    if (packet.packet_type == 'queue_update') {
      this.onQueueUpdate && this.onQueueUpdate(packet.calls, packet.total_count);
    } else if (packet.packet_type == 'claim_status') {
      this.onCallClaimed && this.onCallClaimed(packet);
    } else if (packet.packet_type == 'claim_notification') {
      this.onCallRemoved && this.onCallRemoved(packet.call_ids);
    } else {
      console.error(`unknown packet type: '${packet.packet_type}'\n${JSON.stringify(packet)}`);
    }
  }

  claimCall(call_id) {
    return new Promise((resolve, reject) => {
      if (this.onCallClaimed != null || !this.connected) {
        reject();
      }
      let resolved = false;
      const timeout = setTimeout(() => {
        if (resolved) {
          return;
        }
        resolved = true;
        reject();
      }, 10000);
      this.onCallClaimed = (data) => {
        this.onCallClaimed = null;
        clearTimeout(timeout);
        if (resolved) {
          return;
        }
        resolved = true;
        resolve({ status: data.status, callId: data.call_id, auth: data.auth });
      };
      this.socket.send(`claim$${JSON.stringify({ call_id: call_id })}`);
    });
  }

  getQueue() {
    return new Promise((resolve, reject) => {
      if (this.onQueueUpdate != null || !this.connected) {
        reject();
      }
      let resolved = false;
      const timeout = setTimeout(() => {
        if (resolved) {
          return;
        }
        resolved = true;
        reject();
      }, 10000);
      this.onQueueUpdate = (calls, total_count) => {
        this.onQueueUpdate = null;
        clearTimeout(timeout);
        if (resolved) {
          return;
        }
        resolved = true;
        resolve({ calls, totalCount: total_count });
      };
      this.socket.send(`queue$`);
    });
  }


}
